import favicon from 'assets/img/themes/launchmobility/favicon.png';
import background from 'assets/img/themes/launchmobility/background.png';
import logo from 'assets/img/themes/launchmobility/logo.png';
import sidebarLogo from 'assets/img/themes/launchmobility/logo-sidebar.png';
import collapsed from 'assets/img/themes/launchmobility/logo-sidebar-collapsed.png';

export default {
  background: {
    src: background,
  },
  logo: {
    src: logo,
    height: '130px',
  },
  sidebar: {
    logo: sidebarLogo,
    collapsed: collapsed,
  },
  page: {
    title: 'Launch',
    favicon: favicon,
    secondTitle: 'Mobility',
    support: 'Launch Mobility Support',
  },
  footer: {
    url: 'https://launchmobility.com',
    copyright: 'Launch Mobility, Inc.',
    version: true,
  },
};
